import { displayToast } from '../../../../helpers/notification';
import { MenuTypes as Type } from '../../../types/menu';

export function getItemListRequest(id: string) {
  return {
    type: Type.GET_ITEM_LIST_REQUEST,
    id,
  };
}

export function getItemListRequestSuccess(data: any) {
  return {
    type: Type.GET_ITEM_LIST_REQUEST_SUCCESS,
    payload: data,
  };
}

export function getItemListRequestFailure(error: any) {
  try {
    if (
      error.response &&
      error.response.data &&
      error.response.data.message &&
      error.response.data.message.length > 0
    ) {
      if (Array.isArray(error.response.data.message))
        displayToast('ERROR', error.response.data.message[0]);
      else displayToast('ERROR', error.response.data.message);
    } else {
      displayToast('ERROR', error.message);
    }
  } catch (e) {
    displayToast('ERROR', error.message);
  }
  return {
    type: Type.GET_ITEM_LIST_REQUEST_FAILURE,
    error: error,
  };
}

export function resetItemListState() {
  return {
    type: Type.RESET_ITEM_LIST_REQUEST,
  };
}
